module.exports = __webpack_public_path__ + "static/media/onecambio.d1815860.jpg";